import { render, staticRenderFns } from "./AddressAE.vue?vue&type=template&id=40a31652&scoped=true&"
import script from "./AddressAE.vue?vue&type=script&lang=js&"
export * from "./AddressAE.vue?vue&type=script&lang=js&"
import style0 from "./AddressAE.vue?vue&type=style&index=0&id=40a31652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a31652",
  null
  
)

export default component.exports